import type { ReactNode } from 'react';

import type { StatusTone } from '@/lib/runTelemetry';
import { cn } from '@/lib/utils';

const TONE_CLASSES: Record<StatusTone, string> = {
  success: 'border-success/30 bg-success-bg text-success-foreground',
  danger: 'border-destructive-border bg-destructive-bg text-destructive-foreground',
  warning: 'border-warning/30 bg-warning-bg text-warning-foreground',
  active: 'border-brand/30 bg-brand-muted text-brand',
  neutral: 'border-border bg-muted/60 text-muted-foreground',
};

const DOT_CLASSES: Record<StatusTone, string> = {
  success: 'bg-success',
  danger: 'bg-destructive',
  warning: 'bg-warning',
  active: 'bg-brand animate-pulse',
  neutral: 'bg-muted-foreground',
};

export function StatusPill({
  tone,
  children,
  className,
}: {
  tone: StatusTone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium',
        TONE_CLASSES[tone],
        className,
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', DOT_CLASSES[tone])} aria-hidden="true" />
      {children}
    </span>
  );
}
